import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NotificationPopup = ({ notification, onClose }) => {
    if (!notification) return null;

    return (
        <AnimatePresence>
            <motion.div
                key={notification.id} // Key ensures animation triggers on new notification
                className="fixed top-5 right-5 z-[100] w-80 bg-dark-500 rounded-xl shadow-2xl border border-dark-400 overflow-hidden cursor-pointer"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100, transition: { duration: 0.3, ease: 'easeIn' } }}
                transition={{ type: 'spring', stiffness: 100, damping: 15 }}
                onClick={onClose} // Close on click
            >
                <div className={`p-4 flex items-start border-l-4 border-${notification.color || 'accent-blue'}`}>
                    <div className={`w-8 h-8 rounded-full bg-${notification.color}/20 text-${notification.color} flex items-center justify-center mr-3 flex-shrink-0 mt-1`}>
                        <i className={`fas ${notification.icon}`}></i>
                    </div>
                    <div className="flex-1">
                        <p className="text-sm font-medium text-white">{notification.title}</p>
                        <p className="text-xs text-gray-300">{notification.message}</p>
                        <p className="text-xs text-gray-500 mt-1">{notification.time || 'Now'}</p>
                    </div>
                    <button onClick={onClose} className="ml-2 text-gray-500 hover:text-white text-xs">×</button>
                </div>
                 {/* Optional progress bar for auto-close */}
                 <motion.div
                    className={`h-1 bg-${notification.color}`}
                    initial={{ width: '100%' }}
                    animate={{ width: '0%' }}
                    transition={{ duration: 5, ease: 'linear' }} // Match timeout in context
                 />
            </motion.div>
        </AnimatePresence>
    );
};

export default NotificationPopup;